import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface Prompt {
    id?: number;
    name: string;
    systemPrompt: string;
    userPrompt: string;
}

@Injectable({
    providedIn: 'root'
})
export class PromptService {
    private apiUrl = `${environment.apiUrl}/Prompts`;

    constructor(private http: HttpClient) {}

    getAll(): Observable<Prompt[]> {
        return this.http.get<Prompt[]>(this.apiUrl);
    }

    getById(id: number): Observable<Prompt> {
        return this.http.get<Prompt>(`${this.apiUrl}/${id}`);
    }

    create(prompt: Prompt): Observable<Prompt> {
        return this.http.post<Prompt>(this.apiUrl, prompt);
    }

    update(id: number, prompt: Prompt): Observable<void> {
        return this.http.put<void>(`${this.apiUrl}/${id}`, prompt);
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}
